import React, {
  useState,
  useEffect,
  useCallback,
} from 'react';
import { useParams } from 'react-router';
import Grid from '@material-ui/core/Grid';
import ReactSelect from 'react-select';
/** hooks */
import { useHttp } from '../../../../hooks/http';
import { useAuth } from '../../../../hooks/auth';
import Typography from '@material-ui/core/Typography';
/** Componentes */
import Layout from '../../../../components/Layout';
import HeaderFilterPlus from '../../../../components/Headers/FilterPlus';
import Card from './Card';
import Pagination from '../../../../components/Pagination';
import Accordion from '../../../../components/Accordion';
import { formatDateTime } from '../../../../utils';
import {
  ListIcon
} from '../../../../styles/icons';

import { Container, WrapperAccordion } from './styles';

/** interfaces */
import { IProximity, IPaginate } from '../../../../interfaces';

interface IManagementOption {
  value: number;
  label: string;
}

const analyticsSelectStyles = {
  control: (base: any) => ({
    ...base,
    minHeight: 40,
    border: '1px solid #ccc',
    borderRadius: 4,
    backgroundColor: '#fff',
    boxShadow: 'none',
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: 4,
    zIndex: 20,
  }),
  menuList: (base: any) => ({
    ...base,
    backgroundColor: '#fff',
    padding: 0,
  }),
  option: (base: any, state: { isFocused: boolean; isSelected: boolean }) => ({
    ...base,
    backgroundColor: state.isSelected ? '#e8e8e8' : state.isFocused ? '#f5f5f5' : '#fff',
    color: '#333',
    cursor: 'pointer',
  }),
  singleValue: (base: any) => ({
    ...base,
    color: '#333',
  }),
  placeholder: (base: any) => ({
    ...base,
    color: '#666',
  }),
  input: (base: any) => ({
    ...base,
    color: '#333',
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    backgroundColor: '#ccc',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#666',
  }),
};

const ListAdm: React.FC = () => {
  const { type } = useParams<{type: string}>();
  const [proximities, setProximities] = useState([]);
  const [filter, setFilter] = useState('');
  const { user } = useAuth();
  const [managements, setManagements] = useState<IManagementOption[]>([]);
  const [selectedManagement, setSelectedManagement] = useState<IManagementOption | null>(null);

  const [paginate, setPaginate] = useState<IPaginate>({
    page: 1, perPage: 10, lastPage: 1, total: 0,
  });

  const { httpGet, loading } = useHttp();

  const breadcrumbs = {
    icon: ListIcon,
    links: [
      { title: `${paginate.total} Abord. de Proximidade`, path: '' },
    ],
  };

  const managementId = selectedManagement?.value ?? user?.allocation?.management_id;

  useEffect(() => {
    async function load():Promise<void> {
      const { status, data } = await httpGet(`/proximities/list-adm/${managementId}`, {
        params: {
          ...paginate,
        },
      });
      if (status === 200) {
        setProximities(data.data);
        setPaginate(data.pagination);
      }
    }

    load();
  }, [filter, user, paginate.page, managementId]); // eslint-disable-line

  const handleSearch = (value: string): void => {
    setPaginate({ ...paginate, page: 1 });
    setFilter(value);
  };

  const handlePaginate = (payload: IPaginate): void => {
    setPaginate(payload);
  };

  const handleManagementChange = (opt: IManagementOption | null) => {
    setSelectedManagement(opt);
  };

  const loadManagements = useCallback(async () => {
    const { status, data } = await httpGet('/sectors/managements');
    if (status === 200 && Array.isArray(data)) {
      const managementParsed: IManagementOption[] = data.map((management: { id: number; initials: string }) => ({
        value: management.id,
        label: management.initials,
      }));
      setManagements(managementParsed);
    }
  }, [httpGet]);

  useEffect(() => {
    loadManagements();
  }, [loadManagements]);


  return (
    <Layout breadcrumbs={breadcrumbs} loading={loading}>
      <Container>
        <HeaderFilterPlus handleSearch={handleSearch} />
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={6} >
          <Typography variant="caption" display="block" gutterBottom>
            Gerência
          </Typography>
          <ReactSelect<IManagementOption>
            options={managements}
            value={selectedManagement}
            onChange={(opt) => handleManagementChange(opt as IManagementOption | null)}
            placeholder="Selecione a gerência"
            styles={analyticsSelectStyles}
            noOptionsMessage={() => 'Nenhuma gerência'}
          />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          {proximities && proximities.map((proximity: IProximity) => (
            <Grid item xs={12} sm={12} md={12}>
             <WrapperAccordion key={proximity.id}>
              <Accordion 
               title={`${proximity.assistances.description} 
               - ${formatDateTime(proximity.created_at)}`}
                  content={<Card
                  key={proximity.id}
                  proximity={proximity}
                  type={type}
                />
                }
              >
              </Accordion>
             </WrapperAccordion>
            </Grid>
          ))}
        </Grid>
        <Pagination paginate={paginate} handlePaginate={handlePaginate} />
      </Container>
    </Layout>
  );
};

export default ListAdm;
